




















































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { CbtSheetListCondition, RowSpanInfo } from "../../modules/teacher/CbtSheetList"

export interface Data {
  condition: CbtSheetListCondition
  sheets: any[]
  totalCount: number
  sheetRowSpanInfos: RowSpanInfo[]
  errors: string[]
  isShow: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new CbtSheetListCondition(),
      sheets: [],
      totalCount: 0,
      sheetRowSpanInfos: new Array<RowSpanInfo>(),
      errors: new Array<string>(),
      isShow: false
    });

    /******************************
     * 試験名の横幅 最長文字の文字数から計算して返却する
     ******************************/

    const sheetNameWidth = computed(() => {
      if(state.sheets.length == 0){
        return 65;
      }
      var maxLength = state.sheets.map(x => x.name == null ? 0 : x.name.length).reduce((a,b)=>Math.max(a,b));
      return maxLength > 3 ? maxLength * 20 : 65;
    });

    /******************************
     * 科目名の横幅 最長文字の文字数から計算して返却する
     ******************************/

    const subjectNameWidth = computed(() => {
      if(state.sheets.length == 0){
        return 65;
      }
      var maxLength = state.sheets.map(x => x.subject_name == null ? 0 : x.subject_name.length).reduce((a,b)=>Math.max(a,b));
      return maxLength > 3 ? maxLength * 20 : 65;
    });

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/teacher/cbt_sheet_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        const sheets = response.data.sheets;

        const sheetRowSpanInfos = new Array<RowSpanInfo>();
        for(let i = 0; i < sheets.length; i++){
          const sheet = sheets[i];
          if(sheetRowSpanInfos.length == 0 || sheetRowSpanInfos[sheetRowSpanInfos.length - 1].sheet_group_key != sheet.sheet_group_key){
            sheetRowSpanInfos.push(new RowSpanInfo(sheet.id, sheet.sheet_group_key, 1));
          }else{
            sheetRowSpanInfos[sheetRowSpanInfos.length - 1].count++;
          }
        }
        state.sheetRowSpanInfos = sheetRowSpanInfos;

        if(sheets.length > 0){
          state.totalCount = sheets[0].at_full_count;
        }
        
        state.sheets = sheets;

        context.root.$store.commit("setCbtSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    }

    /******************************
     * クリアボタン押下
     ******************************/
    
    const clearCondition = () => {
      state.condition = new CbtSheetListCondition();
    };

    /******************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ******************************/

    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");

      if(tableArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop - 70) + "px";
      }
    };

    /******************************
     * 0埋め
     ******************************/
    const padZero = (v: number) => {
      if (v < 10) {
        return "0" + v;
      }
      else {
        return v;
      }
    };

    /******************************
     * 秒を時分秒に変換する
     ******************************/

    const convertToHms = (time: number) =>  {
      let hms = "";
      const h = time / 3600 | 0;
      const m = time % 3600 / 60 | 0;
      const s = time % 60;

      if (h != 0) {
        hms = h + "時間" + padZero(m) + "分" + padZero(s) + "秒";
      } else if (m != 0) {
        hms = m + "分" + padZero(s) + "秒";
      } else {
        hms = s + "秒";
      }

      return hms;
    };

    /******************************
     * 一覧テーブル rowspan設定
     * 同一sheet_group_keyの先頭レコードの場合
     * rowspanを設定する
     ******************************/
    
    const rowSpan = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? rowInfo[0].count : 1;
    };

    /******************************
     * 一覧テーブル tdの表示制御
     * rowspan未設定行を非表示にする
     ******************************/
    
    const tdStyle = (sheet: any) => {
      const rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? {} : {"display": "none"};
    };

    /******************************
     * 一覧テーブル trのスタイル
     ******************************/
    
    const trStyle = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_group_key == sheet.sheet_group_key);
      if(rowInfo.length > 0){
        var rowIdx = state.sheetRowSpanInfos.indexOf(rowInfo[0]);
        return rowIdx % 2 == 1 ? {"background-color": "#f2f2f2"} : {};
      }
    };

    /******************************
     * 実施日列の表示用に日付文字列をコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * テスト日時列の表示用に日付文字列をコンバート
     ******************************/
    const convertTestStartDateTime = (datetime: string) => {
      if(datetime == null){
        return "";
      }

      const testStartDateTimeAt = new Date(datetime);
      return moment(testStartDateTimeAt).format('Y年M月D日 HH:mm'); 
    };

    /******************************
     * 一覧のページ変更
     ******************************/
    
    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 試験追加ボタン押下
     ******************************/

    const addSheetClick = () => {
      context.root.$router.push('/teacher_site/cbt_sheet_edit/new').catch(err => {});
    };

    /******************************
     * 採点設定アイコン押下
     ******************************/
    
    const saitenSettingClick = (sheet: any) => {

      // 採点設定の進捗により遷移先を制御
      if(sheet.question_image_completed){
        context.root.$router.push(`/teacher_site/kaitou_pdf_upload/${sheet.sheet_group_key}`).catch(err => {});
      }else if(sheet.score_positions_completed){
        context.root.$router.push(`/teacher_site/mondai_pdf_upload/${sheet.sheet_group_key}`).catch(err => {});
      }else if(sheet.field_positions_completed){
        context.root.$router.push(`/teacher_site/score_position_edit/${sheet.sheet_group_key}`).catch(err => {});
      }else if(sheet.corretct_image_completed){
        context.root.$router.push(`/teacher_site/position_edit/${sheet.sheet_group_key}`).catch(err => {});
      }else if(sheet.field_names_completed){
        context.root.$router.push(`/teacher_site/correct_image_upload/${sheet.sheet_group_key}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/field_edit/${sheet.sheet_group_key}`).catch(err => {});
      }
    };
    
    /******************************
     * 画面リロード
     ******************************/

    const reload = () => {
      location.reload();
    };

    /******************************
     * 公開フラグ更新
     ******************************/

    const updateResultPublished = async (sheet: any) => {
      if(!window.confirm("公開状態を切り替えます。よろしいですか？")){
        return;
      }
      const flg = !sheet.result_published;
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/cbt_sheet_list/update_result_published/${sheet.sheet_group_key}`, {flg: flg}).then(response => {
        state.sheets.filter(x => x.sheet_group_key == sheet.sheet_group_key).forEach(x => {
          x.result_published = flg;
          alert("処理が完了しました。");
        });
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };


    /******************************
     * 切り出し処理
     ******************************/

    const imageCut = async (sheet: any) => {
      if(!window.confirm("切り出し処理を開始します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/cbt_sheet_list/image_cut/${sheet.id}`).then(response => {
        alert("処理が完了しました。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 締切状態更新
     ******************************/

    const updateDeadLineCompleted = async (sheet: any) => {

      if(!window.confirm("締切状態を切り替えます。よろしいですか？")){
        return;
      }
      const flg = !sheet.deadline_completed;
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/cbt_sheet_list/update_deadline_completed/${sheet.id}`, {flg: flg}).then(response => {
        sheet.deadline_completed = flg;
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 生徒メール送信
     ******************************/

    const sendScheduleMail = async (sheet: any) => {
      
      if(!window.confirm("受験対象の生徒にテスト日程をメールします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/cbt_sheet_list/send_schedule_mail/${sheet.id}`).then(response => {
        sheet.send_mail_completed = true;
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      state.condition = context.root.$store.state.cbtSheetListCondition;
      await search();
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.Cbt);
      state.isShow = true;
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
    });

    return {
      ...toRefs(state),
      sheetNameWidth,
      subjectNameWidth,
      search,
      searchClick,
      clearCondition,
      adjustHeight,
      convertToHms,
      convertTestStartDateTime,
      rowSpan,
      tdStyle,
      trStyle,
      convertExecDate,
      changePage,
      addSheetClick,
      saitenSettingClick,
      reload,
      updateResultPublished,
      sendScheduleMail,
      updateDeadLineCompleted,
      imageCut,
    }
  }
})
